import { DOC_KEY } from '@techchange/pm-specs';
import PropTypes from 'prop-types';

/**
 * A ProseMirror JSON document.
 */
export const proseMirrorDocShape = PropTypes.shape({

	type: PropTypes.oneOf([DOC_KEY]).isRequired,

	content: PropTypes.arrayOf(PropTypes.shape({

		type: PropTypes.string.isRequired,

	})).isRequired,

});

export const appPropTypes = {

	/**
	 * API integrations data for the current user.
	 */
	apiIntegrations: PropTypes.shape({

		/**
		 * The list of API integrations.
		 */
		data: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The API integration ID.
			 */
			id: PropTypes.string.isRequired,

			/**
			 * The list of oauth integrations token (for current user) related
			 * to the API integration.
			 */
			oauth_integration_tokens: PropTypes.arrayOf(PropTypes.shape({

				/**
				 * The token ID.
				 */
				id: PropTypes.string.isRequired,

			})).isRequired,

		})),

		/**
		 * True, if loading the API integrations data.
		 */
		loading: PropTypes.bool.isRequired,

		/**
		 * The error (if any) related to loading the API integrations data.
		 */
		error: PropTypes.bool.isRequired,

		/**
		 * Callback function to refresh the API integrations data.
		 */
		refresh: PropTypes.func.isRequired,

	}),

	/**
	 * A map of ID -> user data for all users related to a specific scope (i.e. session).
	 */
	allUsers: PropTypes.objectOf(PropTypes.shape({

		/**
		 * The unique UUID for the user.
		 */
		id: PropTypes.string,

		/**
		 * A link to more information about the user, i.e. the user's profile.
		 */
		url: PropTypes.string,

	})),

	/**
	 * The settings for filestack to handle image uploads and rendering.
	 */
	filestack: PropTypes.shape({

		/**
		 * The API key.
		 */
		apiKey: PropTypes.string.isRequired,

		/**
		 * The security policy and signature.
		 */
		security: PropTypes.shape({

			policy: PropTypes.string,

			signature: PropTypes.string,

		}),

		/**
		 * True, if the mode is production.
		 */
		production: PropTypes.bool,

		/**
		 * The path (only needed if production=true).
		 */
		path: PropTypes.string,

		/**
		 * The container (only needed if production=true).
		 */
		container: PropTypes.string,

		/**
		 * The region (only needed if production=true).
		 */
		region: PropTypes.string,

	}),

	/**
	 * A ProseMirror document object
	 */
	proseMirrorDocument: proseMirrorDocShape,

	/**
	 * The TechChange socket instance to handle real-time events.
	 */
	socket: PropTypes.shape({

		/**
		 * Callback function to add an event listener for a real-time event.
		 */
		on: PropTypes.func.isRequired,

		/**
		 * Callback function to remove an event listener for a real-time event.
		 */
		removeListener: PropTypes.func.isRequired,

	}),

	/**
	 * A custom react-intl message object
	 */
	reactIntlMessage: PropTypes.shape({

		/**
		 * The ID of the message to be translated.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The description of the message to be translated.
		 */
		description: PropTypes.string,

		/**
		 * The message to be translated.
		 */
		defaultMessage: PropTypes.string.isRequired,

	}),

};
